common.View.create('website::layouts.Main', {
    onDOMLoad() {
        this.initNavbar();
        this.onScroll();
        this.initAnimations();
    },

    initNavbar() {
        // Give parent .active when has a .active subitem
        $('.navbar-nav .dropdown-menu > .dropdown-item.active').each(function () {
            $(this).parents('.nav-item').find('.nav-link').addClass('active');
        });

        $('.header-bg').addClass('loaded');
    },

    onScroll() {
        $(window).scroll(() => {
            this.setScrolledClass();
        });

        this.setScrolledClass();
    },

    setScrolledClass() {
        let scroll = $(window).scrollTop();

        $('body').toggleClass('scrolled', scroll >= 50);
    },

    initAnimations() {
        let sal = require('sal.js');

        sal({
            threshold: 0.1,
            once: true,
        });
    },
});
